import * as z from 'zod'

import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import { t } from '@flows/core/i18n'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsPremiumBasicNeodigitalDe } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  switch (issue.code) {
    case z.ZodIssueCode.too_small:
      return {
        message: t('sharedFlows_contentsNxt:steps.contents_living_space.input.error.min', {
          min: issue.minimum,
        }),
      }

    case z.ZodIssueCode.too_big:
      return {
        message: t('sharedFlows_contentsNxt:steps.contents_living_space.input.error.max', {
          max: issue.maximum,
        }),
      }
    default:
      return { message: ctx.defaultError }
  }
}

const living_space = (params: ContentsNeoStepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('living_space_square_meters')]:
        BaseSchema_ContentsPremiumBasicNeodigitalDe.shape.living_space_square_meters,
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.new.living_space.title',
        },
      },
      {
        type: 'input',
        shouldTrackValues: true,
        inputType: 'integer',
        name: params.helperFunctions.getParamPath('living_space_square_meters'),
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.property.input.living_space',
        },
      },
      {
        type: 'spacer',
        size: 'small',
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.living_space.info.text',
        },
      },
    ],
    nextStep: 'permanent_residence',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default living_space
